import axios from "./axios"; // Import the centralized Axios instance

const state = {
  cash_bank_mutations: [],
};

const getters = {
  allCashBankMutations: (state) => state.cash_bank_mutations,
};

const actions = {
  async fetchCashBankMutations({ commit }) {
    try {
      commit("resetCashBankMutations");
      const response = await axios.get("/cash-bank-mutation", { params: { page: 1, limit: 25 } });
      commit("setCashBankMutations", response.data);
    } catch (error) {
      console.error("Failed to fetch cash_bank_mutations:", error);
    }
  },
  async createCashBankMutation({ commit }, cash_bank_mutation) {
    try {
      const response = await axios.post("/cash-bank-mutation", cash_bank_mutation);
      commit("addCashBankMutation", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create cash_bank_mutation:", error);
      throw error;
    }
  },
  async fetchCashBankMutationById(_, id) {
    try {
      const response = await axios.get(`/cash-bank-mutation/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch cash_bank_mutation:", error);
      throw error;
    }
  },
  async updateCashBankMutation({ commit }, cash_bank_mutation) {
    try {
      const response = await axios.put(`/cash-bank-mutation/${cash_bank_mutation.id}`, cash_bank_mutation);
      commit("updateCashBankMutation", response.data);
    } catch (error) {
      console.error("Failed to update cash_bank_mutation:", error);
      throw error;
    }
  },
  async deleteCashBankMutationById({ commit }, id) {
    try {
      const response = await axios.delete(`/cash-bank-mutation/${id}`);
      commit("removeCashBankMutation", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete cash_bank_mutation:", error);
      throw error;
    }
  },
};

const mutations = {
  setCashBankMutations(state, cash_bank_mutations) {
    state.cash_bank_mutations = cash_bank_mutations.data; // Ensure this matches your API's response structure
  },
  addCashBankMutation(state, cash_bank_mutation) {
    state.cash_bank_mutations.push(cash_bank_mutation);
  },
  updateCashBankMutation(state, updatedCashBankMutation) {
    const index = state.cash_bank_mutations.findIndex(
      (cash_bank_mutation) => cash_bank_mutation.id === updatedCashBankMutation.id
    );
    if (index !== -1) {
      state.cash_bank_mutations.splice(index, 1, updatedCashBankMutation);
    }
  },
  removeCashBankMutation(state, id) {
    state.cash_bank_mutations = state.cash_bank_mutations.filter(
      (cash_bank_mutation) => cash_bank_mutation.id !== id
    );
  },
  resetCashBankMutations(state) {
    state.cash_bank_mutations = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
